import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ReportsPage } from './reports';
import { ProfilePage } from '../profile/profile';

@NgModule({
  declarations: [
    ReportsPage,
  ],
  imports: [
    IonicPageModule.forChild(ReportsPage),
  ],
  entryComponents: [
    ProfilePage
  ]
})
export class ReportsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/reports/reports.module.ts